import React, { useState, useEffect } from "react";
import "./LevelMenu.css";
import { getKelompok } from "../../App";
import returnImg from "../../Assets/return-light.svg";

function LvlButton(props) {
  let [Nilai, setNilai] = useState(0);
  let [color, setColor] = useState();

  function CalculateNilai(lvl) {
    let lvlList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    let nilai = 0;

    lvlList.forEach((el) => {
      let answers = JSON.parse(
        localStorage.getItem(`Level${lvl.level}_no${el}`)
      );
      if (!answers) {
        return;
      }

      if (answers.true === true) {
        nilai += 10;
      }
    });

    return new Promise((resolve, reject) => {
      resolve(Promise.resolve(nilai));
    });
  }

  useEffect(() => {
    CalculateNilai(props.lvl).then((nilai) => {
      setNilai(nilai);
      if (nilai >= 80) {
        setColor("green");
      }

      if (nilai < 80 && nilai >= 50) {
        setColor("yellow");
      }

      if (nilai < 50) {
        setColor("red");
      }
    });
  });

  return (
    <div
      className="level"
      onClick={() => (window.location.href = `/level/${props.lvl.level}`)}
    >
      Level {props.lvl.level}
      <div className="flex-wrapper">
        <div className="single-chart">
          <svg viewBox="0 0 36 36" className={`circular-chart ${color}`}>
            <path
              className="circle-bg"
              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${Nilai}, 100`}
              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="20.35" className="percentage">
              {Nilai}%
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
}

function LevelMenu() {
  let [tempArray, setTempArray] = useState([]);

  useEffect(() => {
    getKelompok().then((arr) =>
      arr.forEach((el) => {
        setTempArray((tempArray) => [...tempArray, el.data()]);
      })
    );
  }, []);

  return (
    <div>
      <div className="lvlPage">
        <div className="return-wrap">
          <a href="/" className="return">
            <img src={returnImg} width="20px" alt="Return Icon"></img>
          </a>
        </div>

        <div className="Levels">
          <div className="Kelompok">
            {React.Children.toArray(
              tempArray
                .sort((a, b) => a.level - b.level)
                .map((data) => <LvlButton lvl={data}></LvlButton>)
            )}
          </div>
        </div>
        <div className="circle"></div>
        <div className="diamond"></div>
      </div>
    </div>
  );
}

export default LevelMenu;
